﻿import { Component } from '@angular/core';
import { APIDndRegistrationDetails } from '../../_services/dnd-registration-details/API-dnd-registration-details';
import { APIConstants } from '../../../../_config/restapis';
import { HttpClient } from '@angular/common/http';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Lifecycle } from '../../../../_helpers/Lifecycle/Lifecycle.class';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import * as crypto from 'crypto-js';
import { APIEncryptionDecryption } from '../../_services/CommonService/API-Common-Service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { formatDate } from '@angular/common';
import { BnNgIdleService } from 'bn-ng-idle';
import { Router, ActivatedRoute } from '@angular/router';


const today = new Date();
let UCCdateformated = formatDate(today, 'yyyy-MM-dd', 'en-US', '+0530');


@Component({
  selector: 'app-dnd-registration-details',
  templateUrl: './dnd-registration-details.component.html',
  styleUrls: ['./dnd-registration-details.component.css']
})
export class DndRegistrationDetailsComponent extends Lifecycle {

  catdes: boolean;
  counter3: number = 0;
  counter: number = 0;
  counter1: number = 0;
  counter2: number = 0;
  mocdes: boolean = false;
  dtdes: boolean = false;
  tbdes: boolean = false;
  communicationPerf: any;
  mySelection: boolean = false;
  mySelection1: boolean = false;
  mySelection2: boolean = false;
  atleastOne: boolean = false;
  sts: any;
  srvac: any;
  atleastProm: boolean = false;
  atleastDt: boolean = false;
  atleastMOC: boolean = false;
  atleastTb: boolean = false;
  // For Mode of communcations
  mocCheck: boolean = false;
  mocArray: Array<number> = [];
  tbArray: Array<number> = [];
  dtArray: Array<number> = [];
  modeOfCommunicationData = new Map([[11, 'Voice Call'],
  [13, 'Auto Dialer Call with Pre-recorded'], [14, 'Auto Dialer Call with Live Agent'], [15, 'Robo-calls']]);

  // For Time Bands
  tbCheck: boolean = false;
  timeBandsData = new Map([[21, '00:00 Hrs to 06:00 Hrs'], [22, '06:00 Hrs to 08:00 Hrs'], [23, '08:00 Hrs to 10:00 Hrs'],
  [24, '10:00 Hrs to 12:00 Hrs'], [25, '12:00 Hrs to 14:00 Hrs'], [26, '14:00 Hrs to 16:00 Hrs'],
  [27, '16:00 Hrs to 18:00 Hrs'], [28, '18:00 Hrs to 21:00 Hrs'], [29, '21: 00 Hrs to 24:00 Hrs']]);

  //For Day Type
  dtCheck: boolean = false;
  ctCheck: boolean = false;

  daysData = new Map([[31, 'Mon'], [32, 'Tue'], [33, 'Wed'], [34, 'Thu'], [35, 'Fri'],
  [36, 'Sat'], [37, 'Sun'], [38, 'Public Holiday & National Holiday']]);

  //For category
  categoryData = new Map([[1, 'Banking / Insurance / Financial products / credit cards'],
  [2, 'Real Estate'], [3, 'Education'],
  [4, 'Health'], [5, 'Consumer Goods and Automobiles'], [6, 'Communication / Broadcasting / Entertainment / IT'],
  [7, 'Tourism and Leisure'], [8, 'Food and Beverages']]);

  public communicationPerfCheckbox: any = [];
  public timeband: any = [];
  public days: any = [];
  public promotionMessageData = [];
  public modeOfCommunication: any = [];
  public promotionMessage: any = [];
  public subscriberdetails: any;
  virtual_id: any;
  decrypted_mob: any;
  prefDay: string = "";
  prefMode: string = "";
  prefCategory: string = "";
  prefTime: string = "21,22,23,29";
  promotionMessagee: string = "";

  selectedCommPerf: string = "";
  public prefSetFlag: boolean = false;




  constructor(
    private formBuilder: FormBuilder,
    private _call: APIDndRegistrationDetails,
    private http: HttpClient,
    private $modal: $ModalManagerService,
    private evt: $BroadcastManagerService,
    private db: $DBManagerService,
    // private _calll: APITelemarketer,
    private encryDecry: APIEncryptionDecryption,
    private bnIdle: BnNgIdleService,
    private router: Router,

  ) {
    super();
  }

  dndRegistrationForm: FormGroup;

  submitted: boolean = false;

  _initialize(): void {


    this.dndRegistrationForm = this.formBuilder.group({
      communicationPerf: ['', Validators.required],
      modeOfComm: this.formBuilder.group({}, Validators.required),
      timeBands: this.formBuilder.group({}, Validators.required),
      dayType: this.formBuilder.group({}, Validators.required),
      category: this.formBuilder.group({}, Validators.required),
    });

    //this.selectedCommPerf = 'others';

    // For Mode of Communication checkboxes
    this.modeOfCommunicationData.forEach((option: any, key) => {
      const checkboxes = <FormGroup>this.dndRegistrationForm.get('modeOfComm');
      checkboxes.addControl(option, new FormControl(false));
    });
    // For Time Bands checkboxes
    this.timeBandsData.forEach((option: any) => {
      const checkboxes = <FormGroup>this.dndRegistrationForm.get('timeBands');
      checkboxes.addControl(option, new FormControl(false));
    });
    // For Day Type checkboxes
    this.daysData.forEach((option: any) => {
      const checkboxes = <FormGroup>this.dndRegistrationForm.get('dayType');
      checkboxes.addControl(option, new FormControl(false));
    });
    // For Day Type checkboxes
    this.categoryData.forEach((option: any) => {
      const checkboxes = <FormGroup>this.dndRegistrationForm.get('category');
      checkboxes.addControl(option, new FormControl(false));
    });


    this.evt.emit({ 'click': 'HEADER_EVENT' });

    //console.log("promotionMessageData ::: ", this.promotionMessageData);
    const checkboxes = <FormGroup>this.dndRegistrationForm.get('category');
    this.promotionMessageData.forEach((option: any) => {
      checkboxes.addControl(option.Record.prefName, new FormControl(false));
    });
    this.APIgetSubscriberPreferenceDetails();
	this.getSrvac();

  }

  get f() { return this.dndRegistrationForm.controls; }


  // user defined order for keyvalue pipe
  customOrder = () => { return 0; }

  _destroy(): void {
    this.promotionMessageData = [];
    this.modeOfCommunication = [];
    this.timeband = [];
    this.days = [];
    //this.promotionMessage = [];
  }
  reset1() {
    
    this.dndRegistrationForm.reset();
    // this.mySelection=false;
    this.counter = 0;
    this.counter1 = 0;
    this.counter2 = 0;
    this.counter3 = 0;

  }



  APIgetSubscriberPreferenceDetails(): void {

    let serviceprovider = "TA"
    let mobilenumber = this.db.get(Constants.SESSSION_STORAGE, Constants.MOBILE_NO);

    if (mobilenumber) {

      this._call.getSubscriberPreferenceDetails(mobilenumber)
        .subscribe(r => {
         // console.log("this.subscriberdetails ___________", this.subscriberdetails);
          this.subscriberdetails = r;

          if (this.subscriberdetails.preferences != null) {
            if (this.subscriberdetails.preferences.sts != "T") {

              this.prefDay = this.subscriberdetails.preferences.day;
              this.prefMode = this.subscriberdetails.preferences.cmode;
              this.prefTime = this.subscriberdetails.preferences.time;
              this.promotionMessagee = this.subscriberdetails.preferences.ctgr;
              this.sts = this.subscriberdetails.preferences.sts;
              if (this.subscriberdetails.preferences.ctgr.length === 13) {
                //   console.log("checking for the error message after response");

                this.counter3 = 7;
              }
              if (this.subscriberdetails.preferences.time.length === 23) {
                //  console.log("checking for the error message after response");

                this.counter1 = 8;
              } if (this.subscriberdetails.preferences.cmode.length === 11) {
                //  console.log("checking for the error message after response");

                this.counter = 4;
              }
              if (this.subscriberdetails.preferences.day.length === 20) {
                //   console.log("checking for the error message after response");

                this.counter2 = 7;
              }

            }

          }
          switch (this.promotionMessagee) {
            case "0":
              if (this.sts == "A") {
                this.selectedCommPerf = 'fullyblocked';
               // console.log("A", this.selectedCommPerf);
              }
              else if (this.sts == "D") {
                this.selectedCommPerf = 'unblockall';
               //console.log("D", this.selectedCommPerf);
              }
              break;

            case "50":
              this.selectedCommPerf = 'blockonly';
              break;
            case "90":
              this.selectedCommPerf = 'unblockall';
              break;
            default:
              console.log("sdfg");
              this.selectedCommPerf = 'others';
              break;
          }
        
          const mocCheckbox = <FormGroup>this.dndRegistrationForm.get('modeOfComm');
          const mocTimeband = <FormGroup>this.dndRegistrationForm.get('timeBands');
          const mocDay = <FormGroup>this.dndRegistrationForm.get('dayType');
          const mocCategory = <FormGroup>this.dndRegistrationForm.get('category');

          if(this.prefDay == "30"){
            this.daysData.forEach((opt, key) => {
                mocDay.controls[opt].setValue(true);
            });
          }
          else{
          this.prefDay.split(",").map(Number).forEach(arval => {
            this.daysData.forEach((opt, key) => {
              if (key == arval)
                mocDay.controls[opt].setValue(true);
            });
          })
        }
          if(this.prefMode == "10"){  
            this.modeOfCommunicationData.forEach((opt, key) => {
                mocCheckbox.controls[opt].setValue(true);
            });
          }
          else{
          this.prefMode.split(",").map(Number).forEach(arval => {
            this.modeOfCommunicationData.forEach((opt, key) => {
              if (key == arval)
                mocCheckbox.controls[opt].setValue(true);
            });
          })
        }
          if(this.prefTime == "20"){
            this.timeBandsData.forEach((opt) => { 
                mocTimeband.controls[opt].setValue(true);
            }); 
          }
          else{
          this.prefTime.split(",").map(Number).forEach(arval => {
            this.timeBandsData.forEach((opt, key) => {
              if (key == arval)
                mocTimeband.controls[opt].setValue(true);
            });
          })
         }

          
          this.promotionMessagee.split(",").map(Number).forEach(arval => {
            this.categoryData.forEach((opt, key) => {
              //For hardcoded category
              if (key == arval)
                //mocCategory.controls[opt.Record.prefname].setValue(true);

                //For hardcoded category
                mocCategory.controls[opt].setValue(true);
            });

          })
          // }



        })
    }
  }

      getSrvac(){
	 let mobilenumber = this.db.get(Constants.SESSSION_STORAGE, Constants.MOBILE_NO);

    if (mobilenumber) {

      this._call.getSrvac(mobilenumber)
        .subscribe(r => {
			this.srvac = r;
			
		}) 
    }
   }
   
  onChangeSelectAll(event) {
    this.atleastOne = false;
    this.atleastProm = false;
    this.atleastDt = false;
    this.atleastMOC = false;
    this.atleastTb = false;
    switch (event.source.id) {
      case "mocSelectAll":
        const mocCheckbox = <FormGroup>this.dndRegistrationForm.get('modeOfComm');
        if (event.checked) { this.modeOfCommunicationData.forEach(opt => mocCheckbox.controls[opt].setValue(true)); }
        else {
          this.modeOfCommunicationData.forEach(opt => mocCheckbox.controls[opt].setValue(false)); this.atleastOne = false;
          this.atleastProm = false;
          this.atleastDt = false;
          this.atleastMOC = false;
          this.atleastTb = false;
        }
        break;
      case "tbSelectAll":
        const tbcheckbox = <FormGroup>this.dndRegistrationForm.get('timeBands');
        if (event.checked) { this.timeBandsData.forEach(opt => tbcheckbox.controls[opt].setValue(true)); }
        else {
          this.timeBandsData.forEach(opt => tbcheckbox.controls[opt].setValue(false)); this.atleastOne = false;
          this.atleastProm = false;
          this.atleastDt = false;
          this.atleastMOC = false;
          this.atleastTb = false;
        }
        break;
      case "dtSelectAll":
        const dtcheckbox = <FormGroup>this.dndRegistrationForm.get('dayType');
        if (event.checked) { this.daysData.forEach(opt => dtcheckbox.controls[opt].setValue(true)); }
        else {
          this.daysData.forEach(opt => dtcheckbox.controls[opt].setValue(false)); this.atleastOne = false;
          this.atleastProm = false;
          this.atleastDt = false;
          this.atleastMOC = false;
          this.atleastTb = false;
        }
        break;
    }
  }

  onChangeCommPref(event) {
    if (event.value != 'others') {
      this.atleastOne = false;
      this.mocdes = false;
      this.tbdes = false;
      this.tbdes = false;
    }
    const tbcheckbox = <FormGroup>this.dndRegistrationForm.get('timeBands');
    if (this.subscriberdetails.preferences.time.length != 8 && this.counter1 == 0) {
		
      let prefTime1 = "21,22,23,29";
      prefTime1.split(",").map(Number).forEach(arval => {
        this.timeBandsData.forEach((opt, key) => {
          if (key == arval)
            tbcheckbox.controls[opt].setValue(true);
        });
      });
    }

  }

  // to deselect the categories all checkbox
  catDeSelect(event3): void {

    if (event3.checked) {
      this.counter3 = this.counter3 + 1;
    }
    else {
      this.counter3 = this.counter3 - 1;
    }
    console.log("event: ", event);
    const catCheckbox = <FormGroup>this.dndRegistrationForm.get('category');
    this.categoryData.forEach((opt, key) => {
      if (catCheckbox.controls[opt].value) {

        this.ctCheck = false; this.atleastOne = false; this.catdes = false;
        this.atleastProm = false;
        this.atleastDt = false;
        this.atleastMOC = false;
        this.atleastTb = false;
      }
    });
   // if (this.counter3 > 7) {
    //  this.catdes = true;
   // }
   // else {
    //  this.catdes = false;
   // }
   // console.log("counter: ", this.counter3);
  }
  // To de-select moc select all checkbox
  mocDeSelect(event): void {

    if (event.checked) {
      this.counter = this.counter + 1;
    }
    else {
      this.counter = this.counter - 1;
    }
    console.log("event: ", event);
    const mocCheckbox = <FormGroup>this.dndRegistrationForm.get('modeOfComm');
    this.modeOfCommunicationData.forEach((opt, key) => {
      if (mocCheckbox.controls[opt].value) {

        this.mocCheck = false; this.atleastOne = false; this.mocdes = false;
        this.atleastProm = false;
        this.atleastDt = false;
        this.atleastMOC = false;
        this.atleastTb = false;
      }
    });
    if (this.counter > 4) {
      this.mocdes = true;
    }
    else {
      this.mocdes = false;
    }
    console.log("counter: ", this.counter);
  }
  // To de-select time band select all checkbox
  tbDeSelect(event1): void {
    if (event1.checked) {
      this.counter1 = this.counter1 + 1;
    }
    else {
      this.counter1 = this.counter1 - 1;
    }
    console.log("event: ", event1);
    const tbCheckbox = <FormGroup>this.dndRegistrationForm.get('timeBands');
    this.timeBandsData.forEach((opt, key) => {
      if (tbCheckbox.controls[opt].value) {
        this.tbCheck = false; this.tbdes = false; this.atleastOne = false;
        this.atleastProm = false;
        this.atleastDt = false;
        this.atleastMOC = false;
        this.atleastTb = false;
      }
    });
    if (this.counter1 > 8) {
     // this.tbdes = true; //news
    }
    else {
      this.tbdes = false;
    }
    console.log("counter: ", this.counter1);
  }
  // To de-select day type select all checkbox
  dtDeSelect(event2): void {
    if (event2.checked) {

      this.counter2 = this.counter2 + 1;
    }
    else {
      this.counter2 = this.counter2 - 1;
    }
    const dtCheckbox = <FormGroup>this.dndRegistrationForm.get('dayType');
    this.daysData.forEach((opt, key) => {
      if (dtCheckbox.controls[opt].value) {
        this.dtCheck = false; this.dtdes = false; this.atleastOne = false;
        this.atleastProm = false;
        this.atleastDt = false;
        this.atleastMOC = false;
        this.atleastTb = false;
      }

    });

    if (this.counter2 > 7) {
    //  this.dtdes = true; //news
    }
    else {
      this.dtdes = false;
    }
    console.log("counter: ", this.counter2);
  }
  //Added for hardcoded categories categories

  categoryDeSelect(): void {
    const ctCheckbox = <FormGroup>this.dndRegistrationForm.get('category');
    this.promotionMessageData.forEach(opt => { if (ctCheckbox.controls[opt].value) this.ctCheck = false; });
  }

  onSubmit() {
    this.submitted = true;
    var mocArray = new Array();
    const mocCheckbox = <FormGroup>this.dndRegistrationForm.get('modeOfComm');
    this.modeOfCommunicationData.forEach((opt, key) => { if (mocCheckbox.controls[opt].value) mocArray.push(key) });
   // console.log("moc Array: ", mocArray);

   // if (mocArray.length == 4) {
     // console.log("Hello");
      //mocArray = [];
     // mocArray.push(10);
      //this.mocdes = true;
     // return;
    //} 
    var tbArray = new Array();
    const tbCheckbox = <FormGroup>this.dndRegistrationForm.get('timeBands');
    this.timeBandsData.forEach((opt, key) => { if (tbCheckbox.controls[opt].value) tbArray.push(key) });
   // console.log("time bands Array: ", tbArray);
    /* if(tbArray.length == 9){
     console.log("Hello");
     tbArray = [];
     tbArray.push(20);
     } */
    var dtArray = new Array();
    const dtCheckbox = <FormGroup>this.dndRegistrationForm.get('dayType');
    this.daysData.forEach((opt, key) => { if (dtCheckbox.controls[opt].value) dtArray.push(key) });
    //console.log("day type Array: ", dtArray);
    /* if(dtArray.length == 8){
     console.log("Hello");
     dtArray = [];
     dtArray.push(30);  
     } */
    var promArray = new Array();

    //Added for hardcoded categories
    const promCheckbox = <FormGroup>this.dndRegistrationForm.get('category');
    this.categoryData.forEach((opt, key) => { if (promCheckbox.controls[opt].value) promArray.push(key) });
    //console.log("day type Array: ", promArray);
 
    //console.log("prom Array: ", promArray);

    if (this.dndRegistrationForm.invalid) {
      console.log("Invalid Form: ", this.dndRegistrationForm.value);
      return;
    }
    else if (mocArray.length < 1 && tbArray.length < 1 && dtArray.length < 1 && promArray.length < 1 && this.selectedCommPerf === "others") {
      console.log("Please check atleast one checkbox!");
      this.atleastOne = true;
      this.atleastProm = false;
      this.atleastDt = false;
      this.atleastMOC = false;
      this.atleastTb = false;
      return;
    }
    
    else if (mocArray.length < 1 && this.selectedCommPerf === "others") {
      console.log("Please check atleast one checkbox!");
      this.atleastMOC = true;
      return;
    }
    else if (tbArray.length < 1 && this.selectedCommPerf === "others") {
      console.log("Please check atleast one checkbox!");
      this.atleastTb = true;
      return;
    }
    else if (dtArray.length < 1 && this.selectedCommPerf === "others") {
      console.log("Please check atleast one  checkbox!");
      this.atleastDt = true;
      return;
    }
    else if (promArray.length < 1 && this.selectedCommPerf === "others") {
      console.log("Please check atleast one  checkbox!");
      this.atleastProm = true;
      return;
    }


    if (this.selectedCommPerf != "others") {

      promArray = [];

      tbArray = [];

      dtArray = [];

      mocArray = [];

      console.log("Valid Form: ", this.dndRegistrationForm.value);

      this.APIdndRegistration(mocArray, tbArray, dtArray, promArray);

    }


    else {
      console.log("Valid Form: ", this.dndRegistrationForm.value);
      this.APIdndRegistration(mocArray, tbArray, dtArray, promArray);
    }


  }

  async APIdndRegistration(mocArray, tbArray, dtArray, promArray): Promise<any> {
  
    switch (this.selectedCommPerf) {
      case 'fullyblocked':
        this.promotionMessage = [];
        this.promotionMessage.push('0');
        this.sts = "A";
        this.promotionMessage = this.promotionMessage.join(",");
        break;
      case 'blockonly':
        this.promotionMessage = [];
        this.promotionMessage.push('50');
        this.sts = "A";
        this.promotionMessage = this.promotionMessage.join(",");
        break;
      case 'unblockall':
        this.promotionMessage = [];
        // this.promotionMessage.push('0'); 
        this.promotionMessage.push('90');
        this.sts = "D";
        this.promotionMessage = this.promotionMessage.join(",");
        break;
      default:
        this.promotionMessage = promArray.join(",");
        this.sts = "A";
        break;
    }

    const form: FormData = new FormData();
    form.append('event_const', "CNST_PREFERENCE_REGISTRATION_EVENT");
    form.append('category', JSON.stringify(promArray));
    form.append('modeofcommunication', JSON.stringify(mocArray));
    form.append('daypref', JSON.stringify(dtArray));
    form.append('timepref', JSON.stringify(tbArray));


    let days = dtArray.join(",");
    let timeband = tbArray.join(",");
    let modeOfCommunication = mocArray.join(",");


    let promotionMessage = promArray.join(",");

    let mobileNo = this.db.get(Constants.SESSSION_STORAGE, Constants.MOBILE_NO);

    let encrypted_mob = this.db.get(Constants.SESSSION_STORAGE, Constants.VIRTUAL_MOB_ID);




    const today = new Date();
    const ranvalue = today.getTime();
    let Pref_Uniq_Ref_No = "1603" + ranvalue;
    let p = new Date().getTime()
    const epochNow = (new Date).getTime();
    var epochTime = Math.round(epochNow / 1000).toString();
    let entityClass = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_CLASS);

    var rmode;
    if (entityClass == "Tata Employee") {
      rmode = "6";
    }
    else {
      rmode = "1"
    }
    var data = {
      "header": {
        "event_const": "CNST_PREFERENCE_REGISTRATION_EVENT"
      },
      "jsonblob": {
        "msisdn": mobileNo,
       "srvac":this.srvac.toString(),
        "svcprv": "TA",
        "reqno": Pref_Uniq_Ref_No.toString(),
        "rmode": rmode,
        "ctgr": this.promotionMessage,
        "cmode": modeOfCommunication,
        "day": days,
        "time": timeband,
        "lrn": "1234",
        "uts": epochTime.toString(),
        "cts": epochTime.toString(),
        "sts": this.sts,
      }

    };


    //console.log("dnd data    :", data);


    await this._call.upload(data)
      .subscribe(() => {

        if (this.subscriberdetails.preferences == null || this.subscriberdetails.preferences.sts == "T") {

          var dymamic = "new_reg";
          this._call.registrationmailsend(mobileNo, Pref_Uniq_Ref_No.toString(), dymamic)
            .subscribe((res) => {

            });
        }
        else if (this.subscriberdetails.preferences != null && this.selectedCommPerf != "unblockall") {

          var dymamic = "mod_reg";
          this._call.registrationmailsend(mobileNo, Pref_Uniq_Ref_No.toString(), dymamic)
            .subscribe((res) => {

            });
        }
        else if (this.selectedCommPerf == "unblockall") {

          var dymamic = "unblockall";
          this._call.registrationmailsend(mobileNo, Pref_Uniq_Ref_No.toString(), dymamic)
            .subscribe((res) => {

            });
        }

        this.$modal.successModal({
          title: 'Preference Registration',
          msg: 'DND Preference has been Registered Successfully! \n \n  Your Reference ID is ' + Pref_Uniq_Ref_No
        });

        let entityType = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_ROLE);
        if (entityType == "Subscriber") {
          let loginFlag = false;
          this.db.set(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG, loginFlag);
          this.router.navigateByUrl('/subscriber-login');

        }
        if (entityType == "Tata Employee")
          this.router.navigateByUrl('/set-preference');
      });

  }


  promotionSelectAll(cat: any, event: any, item: any, pitem: any): void {

    const checked = event.target.checked;

    this.atleastOne = false;
    this.atleastProm = false;
    this.atleastDt = false;
    this.atleastMOC = false;
    this.atleastTb = false;
    !Array.isArray(this.promotionMessage) ? this.promotionMessage = this.promotionMessage.split(",") : '';

    if (cat === 'root') {
      if (checked) {
        if (this.promotionMessage.indexOf(item['Record']['PrefcatID']) === -1) {
          item.child.map(r => r.Record.subcatid).forEach(elm => {
            this.promotionMessage.push(elm);
          }),
            this.promotionMessage.push(item['Record']['PrefcatID'])
        }
      } else {
        item.child.map(r => r.Record.subcatid).forEach(elm => {
          this.promotionMessage.splice(this.promotionMessage.indexOf(elm), 1);
        });
        this.promotionMessage.splice(this.promotionMessage.indexOf(item['Record']['PrefcatID'] + ""), 1)
      }
    } else {
      if (checked) {
        this.promotionMessage.push(item['Record']['subcatid'])
      } else {
        this.promotionMessage.splice(this.promotionMessage.indexOf(item['Record']['subcatid']), 1)
      }
    }

    this.promotionMessage = this.promotionMessage.length !== 2 ? this.promotionMessage.join(",") : this.promotionMessage.join("");

  }

  promotionSelectAl(cat: any, item: any): void {
    console.log(item);
    const checked = true;

    if (cat === 'root') {
      checked && (this.promotionMessage.indexOf(item['Record']['PrefcatID']) === -1) ? (
        item.child.map(r => r.Record.subcatid)
          .forEach(elm => {
            this.promotionMessage.push(elm);
          }),
        this.promotionMessage.push(item['Record']['PrefcatID'])
      ) : item.child.map(r => r.Record.subcatid)
        .forEach(elm => {
          this.promotionMessage.splice(this.promotionMessage.indexOf(elm), 1);
        });
    } else {
      checked ? this.promotionMessage.push(item['Record']['subcatid'])
        : (
          this.promotionMessage.splice(this.promotionMessage.indexOf(item['Record']['subcatid']), 1),
          this.promotionMessage.splice(this.promotionMessage.indexOf(item['Record']['PrefcatID']), 1)
        );

    }
  }

  headerListSelection(itemId: any): void {
    console.log(this.promotionMessageData, itemId);
    this.promotionMessage = [];
    this.promotionSelectAl('root', this.promotionMessageData.filter(r => r['Record']['PrefcatID'] === '' + itemId)[0]);
  }

}
